import { StyleSheet } from 'aphrodite';

export default StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
  },

  articleWrapper: {
    flex: 1,
    alignItems: 'flex-end',
    padding: '40px 40px',
  },

  article: {
    flex: 1,
    overflowY: 'auto',
  },

  editorWrapper: {
    flex: 1,
    backgroundColor: '#F6F8F9',
    padding: '40px 40px 0 40px',
  },

  editorToolbar: {
    flexDirection: 'row',
    marginLeft: -10,
  },

  editorToolbarBtn: {
    marginLeft: 10,
  },

  editorToolbarCount: {
    flex: 1,
    fontSize: 12,
    color: '#878F98',
    justifyContent: 'center',
    alignItems: 'flex-end',
  },

  editorTextarea: {
    flex: 1,
    marginTop: 10,
    marginBottom: 40,
    padding: 20,
    fontSize: 16,
    border: '1px solid #C3CCD1',
    borderRadius: 3,
  },
});



// WEBPACK FOOTER //
// ./src/components/questions/writing/styles.js